(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 989px)');

  const getHeaderSection = () => document.querySelector('.section-header');

  const updateHeaderMetrics = () => {
    if (!MOBILE_QUERY.matches) return;
    const headerSection = getHeaderSection();
    if (!headerSection) return;
    document.documentElement.style.setProperty('--cw-mobile-header-height', `${Math.round(headerSection.getBoundingClientRect().height)}px`);
  };

  const centerCurrentCategory = (root = document) => {
    if (!MOBILE_QUERY.matches) return;
    root.querySelectorAll('[data-cw-category-scroller]').forEach((scroller) => {
      const current = scroller.querySelector('[aria-current="page"]');
      if (!current) return;
      const target = current.offsetLeft - (scroller.clientWidth - current.offsetWidth) / 2;
      scroller.scrollTo({ left: Math.max(0, target), behavior: 'auto' });
    });
  };

  const initializeSubmenus = (root = document) => {
    root.querySelectorAll('[data-cw-mobile-drawer]').forEach((drawer) => {
      if (drawer.dataset.cwSubmenusReady === 'true') return;
      drawer.dataset.cwSubmenusReady = 'true';

      const main = drawer.querySelector('[data-cw-menu-main]');
      const details = drawer.closest('details');
      let activePanel = null;
      let activeTrigger = null;

      const closeSubmenu = (restoreFocus = true) => {
        if (!activePanel) return;
        const panel = activePanel;
        const trigger = activeTrigger;
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (main) main.removeAttribute('aria-hidden');
        window.setTimeout(() => {
          panel.hidden = true;
          if (restoreFocus && trigger) trigger.focus({ preventScroll: true });
        }, 330);
        activePanel = null;
        activeTrigger = null;
      };

      drawer.addEventListener('click', (event) => {
        const openButton = event.target.closest('[data-cw-submenu-open]');
        if (openButton && drawer.contains(openButton)) {
          const panel = drawer.querySelector(`#${CSS.escape(openButton.dataset.cwSubmenuOpen)}`);
          if (!panel) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          activePanel = panel;
          activeTrigger = openButton;
          openButton.setAttribute('aria-expanded', 'true');
          if (main) main.setAttribute('aria-hidden', 'true');
          panel.hidden = false;
          panel.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(() => {
            panel.classList.add('is-active');
            panel.querySelector('[data-cw-submenu-back]')?.focus({ preventScroll: true });
          });
          return;
        }

        if (event.target.closest('[data-cw-submenu-back]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeSubmenu();
        }
      }, true);

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && activePanel) {
          event.stopPropagation();
          closeSubmenu();
        }
      });

      details?.addEventListener('toggle', () => {
        if (!details.open) closeSubmenu(false);
      });
    });
  };

  const initialize = (root = document) => {
    updateHeaderMetrics();
    centerCurrentCategory(root);
    initializeSubmenus(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  const headerSection = getHeaderSection();
  if (headerSection && 'ResizeObserver' in window) {
    new ResizeObserver(updateHeaderMetrics).observe(headerSection);
  }

  window.addEventListener('resize', updateHeaderMetrics, { passive: true });
  MOBILE_QUERY.addEventListener('change', () => initialize());

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:reorder', updateHeaderMetrics);
})();
